import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Block, DefaultText, MediumText, Spinner } from '@guryou/html-components';
import { stateIsLoading, useResourcesNew } from '@guryou/redux';
import StaffCount from 'onboard/components/StaffCount';
import SelectableCubeGroup from 'onboard/components/StaffCube';
import CheckboxInfoContainer from 'onboard/containers/CheckboxInfoContainer';
import FormContainer from 'onboard/containers/FormContainer';
import InfoContainer from 'onboard/containers/InfoContainer';
import MainContainer from 'onboard/containers/MainContainer';
import PlayGuideVideoEmbed from 'onboard/containers/PlayGuideVideoEmbed';
import TitleContainer from 'onboard/containers/TitleContainer';
import { useOnboardContext } from 'onboard/context';
import { guideVideos } from 'onboard/GuideVideosUrls';
import StepButtons from '../StepButtons';

const ServiceStaff = () => {
  const { t } = useTranslation();
  const { serviceState, setServiceState } = useOnboardContext();
  const resources = useResourcesNew();
  const [staffError, setStaffError] = useState(false);
  const [count, setCount] = useState(Number(serviceState.capacity));

  const handleSubmit = data => {
    const resourceIds = data.resources
      ?.split(',')
      .map(item => item.trim())
      .filter(item => item !== '')
      .map(Number);

    const err = resourceIds.length < 1;
    if (err) {
      setStaffError(true);
      return;
    }
    setServiceState({ ...data, resources: resourceIds });
  };

  const preselected = resources?.data && resources.data.length > 0 && [resources?.data[0].id];

  return (
    <MainContainer>
      <FormContainer handleSubmit={handleSubmit}>
        <TitleContainer title={t('ONBOARD.serviceStaffTitle')} />
        <Block lg={10} md={12} xs={12} margin={0} marginTop={6} flexWrap="wrap">
          {stateIsLoading(resources) ? (
            <Spinner />
          ) : (
            <SelectableCubeGroup
              error={staffError}
              setError={setStaffError}
              resources={resources?.data || []}
              values={serviceState?.resources.length > 0 ? serviceState?.resources : preselected}
            />
          )}

          <StaffCount count={count} setCount={setCount} name="capacity" title={t('ONBOARD.howManyPerStaff')} />
        </Block>
        <StepButtons />
      </FormContainer>
      <InfoContainer>
        <MediumText>{t('ONBOARD_TEXT.serviceStaffTitle')}</MediumText>
        <DefaultText fontSize="1.2rem">{t('ONBOARD_TEXT.serviceStaffSubtitle')}</DefaultText>
        <Block margin={0} marginTop={10}>
          <DefaultText fontSize="1.2rem" fontWeight="800">
            {t('ONBOARD_TEXT.serviceStaffCheckboxTitle')}
          </DefaultText>
          <CheckboxInfoContainer text={t('ONBOARD_TEXT.serviceStaffCheckbox1Text')} />
          <CheckboxInfoContainer text={t('ONBOARD_TEXT.serviceStaffCheckbox2Text')} />
          <CheckboxInfoContainer text={t('ONBOARD_TEXT.serviceStaffCheckbox3Text')} />
        </Block>
        <PlayGuideVideoEmbed videoId={guideVideos.serviceStaff.videoId} modalTitle={guideVideos.serviceStaff.title} />
      </InfoContainer>
    </MainContainer>
  );
};

export default ServiceStaff;
